import React from 'react';
import FormValidationError from '@/components/errors/FormValidationError';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import CardsMeasure from '@/components/cards/CardsMeasure';
import WorkspaceCardItems from './WorkspaceCardItems';

const WorkspaceCards = ({
  category,
  hasConditions,
  items,
  itemsPerRow,
  onCheckBoxClick,
  onClick,
  readErrors,
  readStatus,
  single,
}) => (
  <NoRowsWrapper
    buttonIcon="clipboard list"
    className="aridhia-workspace-cards"
    canCreate={hasConditions}
    icon="cube"
    entity="workspace"
    readErrors={readErrors}
    readStatus={[readStatus]}
    items={items}
    loading
    onClick={onClick}
  >
    <FormValidationError labelId="access.destination.workspace" />
    <CardsMeasure itemsPerRow={itemsPerRow}>
      <WorkspaceCardItems
        category={category}
        hasConditions={hasConditions}
        items={items}
        onCheckBoxClick={onCheckBoxClick}
        single={single}
      />
    </CardsMeasure>
  </NoRowsWrapper>
);

export default WorkspaceCards;
